<template>
  <div
    class="w3-sidebar w3-text-white  navigation w3-bar-block w3-collapse w3-card w3-animate-left"
    id="mySidebar"
  >
    <div class="w3-bar-item w3-hide-large w3-pink">
      <a class=" w3-right w3-large w3-hide-large" @click="closeNav">
        &times;
      </a>
      <img
        class="w3-hide-large"
        src="../assets/images/logo-small.png"
        alt="logo"
      />
    </div>

    <div
      class="w3-center w3-margin-top w3-hide-small w3-hide-medium w3-margin-bottom"
    >
      <img src="../assets/images/logo.png" alt="logo" style="width:60%" />
    </div>
    <div @click="Selected('intro')" class="w3-bar-item w3-button w3-hover-teal">
      <div class="w3-cell w3-cell-middle">
        <img class="w3-padding-right" src="../assets/images/me.png" alt="me" />
      </div>
      <div class="w3-cell w3-cell-bottom">
        <span class="w3-padding">About Me</span>
      </div>
    </div>
    <div
      @click="Selected('skills')"
      class="w3-bar-item w3-button w3-hover-teal"
    >
      <div class="w3-cell w3-cell-middle">
        <img
          class="w3-padding-right"
          src="../assets/images/skills.png"
          alt="me"
        />
      </div>
      <div class="w3-cell w3-cell-bottom">
        <span class="w3-padding">Skills</span>
      </div>
    </div>
    <div
      @click="Selected('experience')"
      class="w3-bar-item w3-button w3-hover-teal"
    >
      <div class="w3-cell w3-cell-middle">
        <img
          class="w3-padding-right"
          src="../assets/images/workexperience.png"
          alt="me"
        />
      </div>
      <div class="w3-cell w3-cell-bottom">
        <span class="w3-padding">Experience</span>
      </div>
    </div>
    <div
      @click="Selected('education')"
      class="w3-bar-item w3-button w3-hover-teal"
    >
      <div class="w3-cell w3-cell-middle">
        <img
          class="w3-padding-right"
          src="../assets/images/education.png"
          alt="me"
        />
      </div>
      <div class="w3-cell w3-cell-bottom">
        <span class="w3-padding">Education</span>
      </div>
    </div>
    <div
      @click="Selected('projects')"
      class="w3-bar-item   w3-button w3-hover-teal"
    >
      <div class="w3-cell w3-cell-middle">
        <img
          class="w3-padding-right"
          src="../assets/images/projects.png"
          alt="me"
        />
      </div>
      <div class="w3-cell w3-cell-bottom">
        <span class="w3-padding">Projects</span>
      </div>
    </div>
    <div
      @click="Selected('certificate')"
      class="w3-bar-item w3-button w3-hover-teal"
    >
      <div class="w3-cell w3-cell-middle">
        <img
          class="w3-padding-right"
          src="../assets/images/certificate.png"
          alt="me"
        />
      </div>
      <div class="w3-cell w3-cell-bottom">
        <span class="w3-padding">Certificates</span>
      </div>
    </div>

    <div
      @click="Selected('contact')"
      class="w3-bar-item w3-button w3-hover-teal"
    >
      <div class="w3-cell w3-cell-middle">
        <img
          class="w3-padding-right"
          src="../assets/images/contact1.png"
          alt="me"
        />
      </div>
      <div class="w3-cell w3-cell-bottom">
        <span class="w3-padding">Contact Me</span>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "../main";
export default {
  methods: {
    closeNav() {
      document.getElementById("mySidebar").style.display = "none";
    },
    Selected(value) {
      //this.$emit("selected", value);
      eventBus.$emit("selected", value);
      eventBus.$emit("closeNav");
    },
  },
  created() {
    eventBus.$on("closeNav", () => {
      this.closeNav();
    });
  },
};
</script>
<style>
.navigation {
  background-color: #2c3136;
}
</style>
